import VueLogger from 'vuejs3-logger';
import type { ILoggerOptions } from 'vuejs3-logger/dist/interfaces/logger-options';
import { LogLevels } from 'vuejs3-logger/dist/enum/log-levels';

// const isProduction = process.env.NODE_ENV === 'production';

// FIXME: debug log level
// logLevel: isProduction ? LogLevels.ERROR : LogLevels.INFO,
const options: ILoggerOptions = {
  logLevel: LogLevels.DEBUG,
  isEnabled: true,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

export {
  VueLogger,
  options
};
